(function () {
  "use strict";

  class ProductTitleNoVendorComponent extends HTMLElement {
    constructor() {
      super();
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      if (this._product) {
        this.render();
      }
    }

    render() {
      const title = this?._product?.title || "";
      const brand = this?._product?.brand || "";

      const brandPattern = new RegExp(brand, "gi");

      if (brand) {
        this.innerHTML = `
            <h3 class="rcc-search__product__title">
              ${title.replace(brandPattern, "").trim()}
            </h3>
          `;
      } else {
        this.innerHTML = `
        <h3 class="rcc-search__product__title">
          ${title.trim()}
        </h3>
      `;
      }
    }
  }

  customElements.define(
    "rcc-product-title-no-vendor",
    ProductTitleNoVendorComponent
  );
})();
